<template>
  <div class="modal-gala">
    <div class="modal-gala-close" @click="closeModal">
      <p>x</p>
    </div>
    <div class="modal-gala-content">
      <div class="modal-gala-content-title">
        <p>Vota por: {{ dataForVotes.nombre }}</p>
        <h3>{{ dataForVotes.alias }}</h3>
      </div>
      <div class="modal-gala-content-buttons">
          <div class="modal-gala-content-image">
              <img :src="dataForVotes.imageLink" alt="Imagen de voto" />
          </div>
           <div v-if="!isMobile" style="text-align: center;">
            <small class="text-champagne">“Puedes tambien enviar desde tu celular: <b>{{ dataForVotes.nombre }}</b> al 3338”</small>
          </div>
          <div class="modal-miss-buttons-container">
            <button v-if="isMobile" @click="enviarSMS" :disabled="!dataForVotes.buttonSms">
              <p>SMS - 1 VOTO</p>
              <h5>$590</h5>
            </button>
            <button @click="accionB1" :disabled="!dataForVotes.buttonMpFirst">
              <p>4 VOTOS</p>
              <h5>$1.990</h5>
            </button>
            <button @click="accionB2" :disabled="!dataForVotes.buttonMpSecond">
              <p>20 VOTOS</p>
            <h5>$5.990</h5>
          </button>
          <button @click="accionB3" :disabled="!dataForVotes.buttonMpThird">
            <p>35 VOTOS</p>
            <h5>$9.990</h5>
          </button>
          <button @click="accionB4" :disabled="!dataForVotes.buttonMpFourth">
            <p>90 VOTOS</p>
            <h5>$22.990</h5>
          </button>
          <button @click="accionB5" :disabled="!dataForVotes.buttonMpFifth">
            <p>245 VOTOS</p>
            <h5>$59.990</h5>
          </button>
          <button @click="accionB6" :disabled="!dataForVotes.buttonMpSixth">
            <p>500 VOTOS</p>
            <h5>$99.990</h5>
            <img src="../../assets/gala/images/fire.png" alt="Icono Fuego">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataForVotes: {
      type: Object,
      required: true,
      default: () => {},
    },
    modalIsActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Verifica si el dispositivo es móvil
      isMobile: this.isMobileDevice(),
    };
  },
  watch: {
    dataForVotes: {
      handler(newValue) {
        console.log(newValue);
      },
      deep: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('changeModalIsActive', false);
    },
    isMobileDevice() {
      const ua = navigator.userAgent.toLowerCase();
      return /iphone|ipod|android/i.test(ua); // Verifica si es un dispositivo móvil
    },
    accionB1() {
      this.$gtag.event('mp10_'+this.dataForVotes.nombre, {
        'event_value': this.dataForVotes.nombre
      });

      window.open(this.dataForVotes.buttonMpFirst, '_blank');
    },
    accionB2() {
      this.$gtag.event('mp10_'+this.dataForVotes.nombre, {
        'event_value': this.dataForVotes.nombre
      });

      window.open(this.dataForVotes.buttonMpSecond, '_blank');
    },
    accionB3() {
      this.$gtag.event('mp20_'+this.dataForVotes.nombre, {
        'event_value': this.dataNombre
      });

      window.open(this.dataForVotes.buttonMpThird, '_blank');
    },
    accionB4() {
      this.$gtag.event('mp5_'+this.dataForVotes.nombre, {
        'event_value': this.dataForVotes.nombre
      });
      window.open(this.dataForVotes.buttonMpFourth, '_blank');
    },
    accionB5() {
      this.$gtag.event('mp10_'+this.dataForVotes.nombre, {
        'event_value': this.dataForVotes.nombre
      });

      window.open(this.dataForVotes.buttonMpFifth, '_blank');
    },
    accionB6() {
      this.$gtag.event('mp10_'+this.dataForVotes.nombre, {
        'event_value': this.dataForVotes.nombre
      });

      window.open(this.dataForVotes.buttonMpSixth, '_blank');
    },
    enviarSMS() {
      const ua = navigator.userAgent.toLowerCase();

      // Modificar el nombre solo si es "VIÑA DEL MAR"
      let nombreProcesado = this.dataForVotes.nombre;
      if (nombreProcesado === "VIÑA DEL MAR") {
        nombreProcesado = 'VINADELMAR'
      }

      // Codificar el nombre procesado
      const nombreCodificado = encodeURIComponent(nombreProcesado);

      var esAndroid = /Android/.test(navigator.userAgent);

      this.$gtag.event('click_SMS_' + nombreProcesado, {
        'event_value': nombreProcesado
      });

      if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        window.open(`sms://3338&body=${nombreCodificado}`, '_system');
      } else if (esAndroid) {
        var versionAndroid = parseFloat(navigator.userAgent.slice(navigator.userAgent.indexOf("Android") + 8));
        if (versionAndroid >= 4.4) {
          window.open(`sms:3338?&body=${nombreCodificado}`, '_system');
        } else {
          window.open(`sms://3338?&body=${nombreCodificado}`, '_system');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.text-champagne {
    color: #D9BC7E;
}
.modal-miss-buttons-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 12px;
}
.modal-gala-content-buttons .modal-miss-buttons-container button p {
    font-size: 12px;
}
.modal-gala-content-buttons .modal-miss-buttons-container button h5{
    border: none;
    border-radius: 24px;
    background: linear-gradient(45deg, #AF954F, #E4CE8F);
    color: #1B2A4A;
    box-shadow: 0 4px 12px rgba(191, 169, 108, 0.45);
    font-size: 12px;
    padding: 6px 16px;
    transition: all .3s ease-in-out;
    margin-top: 8px
}

.modal-gala-content-buttons .modal-miss-buttons-container button img {
    position: absolute;
    top: 65%;
    right: 5%;
    width: 20px;
    transform: initial;
}

.modal-gala-content-image {
  margin-bottom: 5px;  /* Espacio entre la imagen y los botones */
  text-align: center;   /* Centra la imagen en su contenedor */
}

.modal-gala-content-image img {
  max-width: 55%; /* Ajusta el tamaño de la imagen, puedes modificar el valor según lo necesites */
  height: 200px;   /* Mantiene la proporción de la imagen */
  margin: 0 auto; /* Centra la imagen dentro del contenedor */
  border-radius: 15%;
  border: 3px solid #BFA96C;
}
@font-face {
  font-family: 'avenir-regular';
  src: url('../../assets/gala/fonts/AVENIR-REGULAR.OTF');
}

@font-face {
  font-family: 'avenir-bold';
  src: url('../../assets/gala/fonts/AVENIR-BOLD.TTF');
}

.modal-gala{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  color: #D9BC7E;
  font-family: avenir-regular;
  background-image: url("../../assets/miss-chile/images/background.jpg");
  background-position: 50%;
  background-size: cover;

  p, h3, h5{
    margin: 0;
  }

  &-close{
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #FFF;

    p{
      color: #000;
      font-size: 20px;
      font-weight: bold;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &-content{
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    max-width: 400px;

    &-title{

      p{
        margin-bottom: 8px;
      }

      h3{
        font-size: 32px;
        font-weight: bold;
      }

      span{
        font-size: 12px;
        font-weight: bold;
        color: #a7a7a7;
      }
    }

    &-buttons{
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      &-sms{
        position: relative;
        text-align: center;
        margin-bottom: 16px;

        span{
          font-size: 12px;
          font-weight: bold;
          color: #a7a7a7;
        }

        button{
          margin-top: 8px;
        }

        &::before{
          content: '';
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          height: 1px;
          background-color: #FFF;
        }
      }

      button{
        outline: none;
        border: 1px solid #BFA96C;
        background-image: linear-gradient(45deg,#061733,#1d1d77);
        border-radius: 8px;
        padding: 6px 16px;
        color: #D9BC7E;
        transition: all .3s;
        position: relative;
        width: 100%;
        overflow: hidden;

        p{
          font-family: 'avenir-bold';
          font-size: 16px;
          font-weight: bold;
        }

        h5{
          font-size: 14px;
        }

        @media (hover: hover) {
          &:hover{
            background-image: linear-gradient(45deg, #464580, #131325);
          }
        }

        img{
          position: absolute;
          top: 65%;
          right: 25%;
          transform: translate(-50%, -50%);
          width: 20px;
        }
      }
    }
  }
}

@media (max-width:768px) {
    .modal-gala{
      background-image: url("../../assets/miss-chile/images/back_mobile.jpg");
    }
    .modal-gala-content-buttons .modal-miss-buttons-container button h5 {
        padding: 6px 0;
    }
    .modal-gala-content-buttons .modal-miss-buttons-container button img {
        top: 50%;
    }
     .modal-gala-content-buttons .modal-miss-buttons-container button {
        padding: 6px;
    }
}
</style>
